import React, { useState, useEffect } from "react";

import Loading from "../../../Extra/Loading";
import SuccessMsg from "../../../Extra/SuccessMsg";
import FailedMsg from "../../../Extra/FailedMsg";
import axios from "axios";
import NoDataFound from "../../../Extra/NoDataFound";

const IndentReport = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [show, setShow] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [id, setId] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}getMultipleTableData?hdr_table=t_indent_hdr&dtl_table=t_indent_dtls&hdr_pk=id&dtl_fk=ind_id&action=pending`,
      );

      if (response.data.success === true) {
        setGridData(response.data.data.sort((a, b) => a.Sno - b.Sno));
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const Data = gridData.map((item) => ({
    ...item.hdr_data,
    source: item.dtl_data
      .filter((d) => d.pick_drop_flag === "S")
      .map((d) => d.pick_drop_point)
      .join(" + "),
    destination: item.dtl_data
      .filter((d) => d.pick_drop_flag === "D")
      .map((d) => d.pick_drop_point)
      .join(" + "),
  }));
  const columnHead = [
    `source`,
    `destination`,
    `via`,
    `quota`,
    `restriction_by_name`,
    `commodity`,
    `wagons`,
    `wagon_type`,
    `fcn_no`,
    `order_date`,
    `restriction_remark`,
    `remarks`,
  ];
  const handleSubmit = async ({ id, action }) => {
    const payload = {
      table_name: "t_indent_hdr",
      rows: [{ id, updates: { action } }],
    };

    setLoading(true);
    try {
      const res = await fetch(`${urlPrefix}updateAllMasterData `, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      setResult(data);
      setShow(true);
      fetchData();
      if (data.success === true);
      {
        setResult(data);
        setShow(true);
      }
    } catch (e) {
      setResult({ status: "failed", message: e.message });
      setShow(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-center mt-1">
      <h4 className="bg-dark text-white p-2 text-center"> Indent Status </h4>

      <div className="table-responsive " style={{ fontSize: "14px" }}>
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>Sr No.</th>
              {columnHead.map((head, index) => (
                <th key={index} style={{ border: "1px solid gray" }}>
                  {head.toUpperCase().replace(/_/g, " ")}
                </th>
              ))}
              <th>ACTION</th>
            </tr>
          </thead>

          <tbody>
            {Data && Data.length > 0 ? (
              Data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>{rowIndex + 1}</td>
                  {columnHead.map((o, i) => (
                    <td key={i}>
                      <div className=" p-2 fw-bold rounded ">
                        {o === "order_date" || o === "report_date"
                          ? row[o]?.slice(0, 10)
                          : row[o]}
                      </div>
                    </td>
                  ))}

                  <td>
                    <button
                      className="btn btn-success me-2 btn-sm"
                      onClick={() =>
                        handleSubmit({ id: row.id, action: "accept" })
                      }
                    >
                      Accept
                    </button>

                    <button
                      className="btn btn-danger me-2 btn-sm"
                      onClick={() =>
                        handleSubmit({ id: row.id, action: "reject" })
                      }
                      // onClick={() => {
                      // }}
                    >
                      Reject
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <td className="" colSpan={columnHead.length + 2}>
                <NoDataFound />
              </td>
            )}
          </tbody>
        </table>
      </div>
      <div className="p-3">
        {result?.success === true ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={`${result?.message || ""}, ${result?.error || ""}`}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>
    </div>
  );
};

export default IndentReport;
